// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-notification__group{\n    width: 100%!important;\n}\n.el-collapse-item__content{position:relative;left:0px;top:0px;}\n", ""]);
// Exports
module.exports = exports;
